// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"036b222b","977":"091499e2"}[chunkId] + ".chunk.js";
};